/**
 * Step 5: Create
 * Name and generate composite identity.
 */
import type React from "react";

export interface CreateStepProps {
  compositeName: string;
  setCompositeName: (name: string) => void;
  selectedAssetIds: string[];
  links: Array<{ id: string }>;
}

export const CreateStep: React.FC<CreateStepProps> = ({
  compositeName,
  setCompositeName,
  selectedAssetIds,
  links,
}) => (
  <div>
    <div className="mb-6">
      <p className="text-sm text-sa-text-muted">
        Give your composite Smart Asset a name and create it.
      </p>
    </div>

    <div className="max-w-md">
      <label htmlFor="composite-name" className="block text-sm font-medium text-sa-text mb-2">
        Composite Name
      </label>
      <input
        id="composite-name"
        type="text"
        value={compositeName}
        onChange={(e) => setCompositeName(e.target.value)}
        placeholder="e.g., PAIR-Treasury Oracle"
        className="w-full px-4 py-2 text-sa-text bg-sa-surface border border-sa-border rounded-lg focus:ring-2 focus:ring-sa-success focus:border-sa-success outline-none"
        data-testid="composite-name-input"
      />
      <p className="mt-2 text-xs text-sa-text-muted">
        This name will identify your composite in the dashboard.
      </p>
    </div>

    <div className="mt-6 p-4 bg-sa-success/10 rounded-lg border border-sa-success/40">
      <h4 className="font-medium text-sa-success mb-2">Ready to Create Composite</h4>
      <ul className="text-sm text-sa-success space-y-1">
        <li>{selectedAssetIds.length} components selected</li>
        <li>
          {links.length} connection{links.length !== 1 ? "s" : ""} configured
        </li>
        <li>New RGB identity will be generated</li>
      </ul>
    </div>
  </div>
);
